<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-cogs'"></top-line>
    <el-row class="pagebody">
      <el-row class="filter-bar">
        <el-button type="primary" icon="el-icon-search" size="small" plain style="margin-left:8px;"
                   class="fr"
                   @click="handleSearch">
          查询
        </el-button>
      </el-row>

      <el-row class="main-table">
        <el-table :data="tableData">
          <el-table-column prop="id" label="ID" align="center" width="75px" />
          <el-table-column prop="model_name" label="显卡型号" width="260px" />
          <el-table-column prop="price_second" label="价格（元/秒）" align="right" width="120px" :formatter="formatPrice" />
          <el-table-column prop="price_second" label="价格（元/月）" align="right" width="120px" :formatter="formatPriceMonth" />
        </el-table>
      </el-row>
    </el-row>
  </d2-container>
</template>

<script>

import topLine from "@/components/save-common/topLine.vue";
import commonListMixin from "@/pages/mixin/mixin-common-list";

export default {
  name: "allns",
  mixins: [
    commonListMixin
  ],
  components: {
    topLine,
  },
  data() {
    return {
      pageTitle: "GPU计费价格",
      labelWidth: '120px',
      tableDataApi: '/api/gpu-price',

      searchForm: {
        gpuModel: '',
      },
      period: [],
      currentRow: {},
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    handleReset() {
      this.searchForm = {
        gpuModel: '',
        from: '',
        to: '',
      }
      this.getTableData();
    },
    handleSearch() {
      this.getTableData();
    },

    formatPrice (value) {
      return parseFloat(value.price_second).toFixed(8)
    },
    formatPriceMonth (value) {
      return (parseFloat(value.price_second)*3600*24*30).toFixed(2)
    },
  }

}
</script>

<style scoped lang="scss">
.pagebody {
  margin-top: 20px;
  margin-left: 20px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}
.batch-button {
  min-width: 95px;
}
</style>
